import React from 'react';
import logo from '../assets/images/logo.png';
import {Button} from "@mui/material";

export const Logo = ({ onClick }) => (
    <Button onClick={onClick} variant="text" sx={{ml: {xs: 2, md: 0}}}>
        <img src={logo} alt="Statcircle"/>
    </Button>
);
